var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c("div", [
                  _c(
                    "h6",
                    { staticClass: "text-uppercase text-primary mb-0" },
                    [_vm._v(_vm._s(_vm.categoria))]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "cursive" }, [
                    _vm._v(_vm._s(_vm.titolo))
                  ])
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-tour-detail" }, [
          _c(
            "div",
            [
              _c("big-carousel", {
                staticClass: "mb-3",
                attrs: { images: _vm.images }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _c("h5", { staticClass: "cursive" }, [
                  _vm._v("Scegli il giorno di partenza")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-md-flex my-3",
                    style: _vm.isMobile ? "" : "height: 35px"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mr-md-2 mb-2 mb-md-0",
                        staticStyle: { "min-width": "250px" }
                      },
                      [
                        _vm.dateSelected
                          ? _c("CustomDatePicker", {
                              attrs: {
                                placeholder: "SCEGLI UNA DATA",
                                "disabled-dates": _vm.disabledDates
                              },
                              model: {
                                value: _vm.dateSelected,
                                callback: function($$v) {
                                  _vm.dateSelected = $$v
                                },
                                expression: "dateSelected"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary px-4",
                        attrs: { id: "procediExperience" },
                        on: {
                          click: function($event) {
                            return _vm.onSelectPartenza()
                          }
                        }
                      },
                      [_vm._v("\n              procedi\n            ")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "tabs",
                { staticClass: "mb-3" },
                [
                  _c("tab", { attrs: { title: "Descrizione" } }, [
                    _c("div", { staticClass: "mb-3" }, [
                      _c("p", {
                        staticClass: "text-justify",
                        domProps: { innerHTML: _vm._s(_vm.descrizione) }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tab",
                    {
                      attrs: { title: "Itinerario" },
                      on: { click: _vm.onClickItinerario }
                    },
                    [
                      _c("h4", { staticClass: "mb-3" }, [
                        _vm._v("Servizi e Trasferimenti")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.itinerario, function(item, index) {
                        return _c(
                          "div",
                          { key: "x" + index, staticClass: "mb-3 row" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-4 pr-md-4" },
                              [
                                _c("small-carousel", {
                                  staticClass: "mb-3",
                                  attrs: { images: item.imagesUrl }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 col-md-8" }, [
                              !item.dateRitorno
                                ? _c("h6", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatDateFromIndex(item.date)
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("h6", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.formatDateFromIndex(item.date)
                                        ) +
                                        " -\n                  " +
                                        _vm._s(
                                          _vm.formatDateFromIndex(
                                            item.dateRitorno
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                              _vm._v(" "),
                              _c("h5", { staticClass: "cursive mb-0" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "mb-1 text-uppercase text-nowrap"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/images/svg/black/icone_passeggeri.svg"),
                                      height: "12px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("small", [
                                    _c("b", [_vm._v(_vm._s(item.line))])
                                  ]),
                                  _vm._v(" "),
                                  item.durata
                                    ? _c("img", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          src: require("../../../../../assets/images/svg/black/icone_durata.svg"),
                                          height: "12px"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.durata
                                    ? _c("small", [
                                        _c("b", [_vm._v(_vm._s(item.durata))])
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-justify" }, [
                                _vm._v(_vm._s(item.description))
                              ])
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      !_vm.isTourNotFound
                        ? _c("h4", { staticClass: "mb-3" }, [
                            _vm._v("Minitour")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.dayByDay, function(item, day) {
                        return !_vm.isTourNotFound
                          ? _c(
                              "div",
                              { key: day, staticClass: "row no-gutters mb-4" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-4 pr-md-4" },
                                  [
                                    _c("small-carousel", {
                                      staticClass: "mb-3",
                                      attrs: { images: item.imagesUrl }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-8" }, [
                                  _c("div", { staticClass: "mb-2" }, [
                                    item.kilometers
                                      ? _c("h6", { staticClass: "mb-0" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(day + 1) +
                                              "° giorno (" +
                                              _vm._s(item.kilometers) +
                                              ") -\n                    " +
                                              _vm._s(item.descriptionTitle) +
                                              "\n                  "
                                          )
                                        ])
                                      : _c("h6", { staticClass: "mb-0" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(day + 1) +
                                              "° giorno - " +
                                              _vm._s(item.descriptionTitle) +
                                              "\n                  "
                                          )
                                        ]),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../../../assets/images/svg/black/icone_durata.svg"),
                                        height: "12px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("small", [_vm._v(_vm._s(item.date))])
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-justify" }, [
                                    _vm._v(_vm._s(item.description))
                                  ]),
                                  _vm._v(" "),
                                  item.categoryDescriptions.length > 0
                                    ? _c("div", [
                                        item.categoryDescriptions.some(function(
                                          cat
                                        ) {
                                          return cat.hotels.length > 0
                                        })
                                          ? _c(
                                              "table",
                                              {
                                                staticClass: "table",
                                                staticStyle: {
                                                  "font-size": "0.75rem"
                                                }
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c("th", [
                                                      _vm._v("Categoria")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Sistemazione")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("th", [
                                                      _vm._v("Trattamento")
                                                    ])
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    item.categoryDescriptions,
                                                    function(cat) {
                                                      return _c(
                                                        "tr",
                                                        { key: cat.category },
                                                        [
                                                          _c("td", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    cat.category
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.hotelNames(
                                                                      cat.hotels
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    cat.treatment
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          : _c(
                                              "table",
                                              {
                                                staticClass: "table",
                                                staticStyle: {
                                                  "font-size": "0.75rem"
                                                }
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { width: "50%" }
                                                      },
                                                      [_vm._v("Categoria")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "th",
                                                      {
                                                        attrs: { width: "50%" }
                                                      },
                                                      [_vm._v("Trattamento")]
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    item.categoryDescriptions,
                                                    function(cat) {
                                                      return _c(
                                                        "tr",
                                                        { key: cat.category },
                                                        [
                                                          _c("td", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    cat.category
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    cat.treatment
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-046013ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046013ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/experience/modals/ModalExperienceDetail.vue
// module id = null
// module chunks = 